import styles from './ScreenWrapper.module.css';

interface ScreenWrapperProps extends React.HTMLAttributes<HTMLDivElement> {}

const ScreenWrapper = ({ className, ...props }: ScreenWrapperProps): React.JSX.Element => (
    <div className={`${styles.screenWrapper}${className ? ` ${className}` : ''}`} {...props} />
);

export { ScreenWrapper };
